jQuery(document).scroll(function() {
if(jQuery('body').width() > 1000) {
	//scroll version 2
	if(jQuery('.fb-scroll').length > 0 && jQuery('body').find('.feedback-detail-scroll.scroll').length > 0) {
		var distance = jQuery('body').find('.feedback-detail-scroll.scroll').offset().top - jQuery(window).scrollTop();
		if (distance < 66) {
			if(!jQuery("main").hasClass("fb-scroll-scrolled")){
				selectedFirst(jQuery('.feedback.selected').attr('id'));
			}
			jQuery("main").addClass("fb-scroll-scrolled");
			var real_width = jQuery('body').find('.feedback-detail-scroll.scroll').width();
		} else {
			if(jQuery("main").hasClass("fb-scroll-scrolled")){
				selectedFirst(jQuery('.feedback.selected').attr('id'));
			}
			jQuery("main").removeClass("fb-scroll-scrolled");
		}
	}

}
});



export function selectedFirst(id) {
    //console.log("selected first");
	if(jQuery('body').find('#'+id).length > 0){
		var disttotop = jQuery('body').find('#'+id).offset().top - jQuery('body').find('.scroll-contents').offset().top;
		var scrolltop = jQuery('body').find('.scroll-contents').first().scrollTop();
        jQuery('body').find('.scroll-contents').first().animate({scrollTop : scrolltop + disttotop});
	}
}

export function detailToTop() {
    //console.log("selected first");
    var distance = jQuery('body').find('.feedbacks').offset().top - jQuery('body').find('.feedbacks').find('.title-row').height() - 30;
    if(jQuery(document).scrollTop() > distance){
        jQuery('body')[0].scrollTop = jQuery(document.documentElement).animate({scrollTop : distance});
    }
}

export function chatDown() {
    const elements = document.querySelectorAll('.chat_widget');

    elements.forEach((el) => {
        if (el && el.scrollHeight > 0) {
            el.scrollTo({top: el.scrollHeight});
        }
    });
}

jQuery(document).ready(function(){
	chatDown();
});

jQuery('.sidebar-toggle').click(function() {
	if(jQuery('body').width() <= 1000) {
		if(jQuery('body').find('.sidebar').hasClass('is-hidden-mobile')) {
			jQuery('body').find('.sidebar').removeClass('is-hidden-mobile');
		} else {
			jQuery('body').find('.sidebar').addClass('is-hidden-mobile');
		}
	}
});


jQuery('body').on('click', '.modal-add-notes-button', function() {
	window.scrollTo(0,jQuery('.feedback-detail h5#notes').offset().top - 150);
	if(document.getElementById('noteInput')){
		document.getElementById('noteInput').focus();
		document.getElementById('noteInput').select();
	}
});
